module.exports = __webpack_public_path__ + "static/media/Group_2.7bfbdf81.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/orderPage4/img/Group_2.png
// module id = 735
// module chunks = 0